import CONFIG from '../../config';

const actions = {
  opsTeamMember(context, params) {
    context.commit('ADD_LOG', { request: 'opsTeamMember' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('opsTeamMember'), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'opsTeamMember' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'opsTeamMember' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },

};
export default actions;
